module.exports = __webpack_public_path__ + "img/whatsapp_banner.04863a9d.jpeg";